import React from 'react';
import { Tag, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import Colors from '../../../../../themes/Colors';
/**
 * Displays the status tag of the spot according to its revision_status and activity.
 * Extracted from RelationSliderComponent (getSpotStatusTag function).
 */
const SpotStatusTag = ({ revisionStatus, rejectReason = '', isActive, isPendingContent }) => {
  const { t } = useTranslation();

  if (revisionStatus === 'approved' && !isPendingContent && isActive === 1) {
    return (
      <Tooltip title={t('Ad state')}>
        <Tag color="green" style={{ marginTop: '3px' }}>
          {t('Spot Approved')}
        </Tag>
      </Tooltip>
    );
  }

  if (isActive === 0) {
    return (
      <Tooltip title={t('Ad state')}>
        <Tag color="yellow" style={{ marginTop: '3px' }}>
          {t('Inactive')}
        </Tag>
      </Tooltip>
    );
  }

  if (revisionStatus === 'rejected' && !isPendingContent) {
    return (
      <Tooltip title={t('Ad state')}>
        <Tag color="red" style={{ marginTop: '3px' }}>
          <span title={rejectReason}>
            {t('Spot Rejected') + ' '}({rejectReason.slice(0, 50)}
            {rejectReason.length > 50 ? '...' : ''} )
          </span>
        </Tag>
      </Tooltip>
    );
  }

  if (revisionStatus === 'pending' && !isPendingContent) {
    return (
      <Tooltip title={t('Ad state')}>
        <Tag color="orange" style={{ marginTop: '3px' }}>
          {t('The owner of this screen has not yet approved')}
        </Tag>
      </Tooltip>
    );
  }

  if (revisionStatus === 'pending_content' && isPendingContent) {
    return (
      <Tooltip title={t('Ad state')}>
        <Tag color="lightgrey" style={{ marginTop: '3px', color: Colors.textSecondary }}>
          {t('On hold')}
        </Tag>
      </Tooltip>
    );
  }

  return null;
};

export default SpotStatusTag;
